import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { LabelService } from '../../services/label.service';
import { LabelAndDescription } from '../../models/patient-model';
import moment from 'moment';

import * as diagnoses from '../../models/DSM-5-TR-grouped.json';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-panel-with-input-boxes',
  templateUrl: './panel-with-input-boxes.component.html',
  styleUrls: ['./panel-with-input-boxes.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
  standalone: false,
})
export class PanelWithInputBoxesComponent implements OnInit, OnChanges {
  @Input() title: string = '';
  @Input() inputBoxes: LabelAndDescription[] = [];
  @Output() cancel = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<LabelAndDescription[]>();

  inputForm: FormGroup;
  private diagnosesJson = diagnoses;
  suggestions: string[] = [];
  isBtnClicked: boolean = false;

  constructor(
    public labelService: LabelService,
    private fb: FormBuilder,
    private dateAdapter: DateAdapter<any>
  ) {
    this.inputForm = this.fb.group({});
    this.dateAdapter.setLocale('it-IT');
  }

  ngOnInit(): void {
    this.initForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['inputBoxes'] && this.inputBoxes.length > 0) {
      this.initForm();
    }
  }

  initForm(): void {
    const formConfig: { [key: string]: any } = {};
    this.inputBoxes.forEach((input) => {
      if (input.label === 'date') {
        formConfig[input.label] = [
          moment(input.description, 'DD/MM/YYYY'),
          Validators.required,
        ];
      } else if (input.label === 'other') {
        formConfig[input.label] = [input.description || ''];
      } else if (input.label === 'notes') {
        formConfig[input.label] = [input.description || ''];
      } else {
        formConfig[input.label] = [
          input.description || '',
          Validators.required,
        ];
      }
    });
    this.inputForm = this.fb.group(formConfig);
  }

  onCancel(): void {
    this.cancel.emit();
  }

  onConfirm(): void {
    if (this.isBtnClicked || this.inputForm.invalid) {
      return;
    }

    const formValues = this.inputForm.value;
    const output = this.inputBoxes.map((input) => ({
      ...input,
      description:
        input.label === 'date'
          ? moment(formValues[input.label]).format('DD/MM/YYYY')
          : formValues[input.label],
    }));

    this.isBtnClicked = true;
    this.confirm.emit(output);
  }

  getSuggestions(input: LabelAndDescription): void {
    this.suggestions = [];
    if (input.label !== 'codeAndDescription') {
      return;
    }
    let query = this.inputForm.get('codeAndDescription')?.value || '';

    if (this.title === 'Nuova Diagnosi' || this.title === 'Modifica Diagnosi') {
      const lowerCaseQuery = query.toLowerCase();

      if (
        typeof this.diagnosesJson === 'object' &&
        this.diagnosesJson !== null
      ) {
        for (const [code, descriptions] of Object.entries(this.diagnosesJson)) {
          if (Array.isArray(descriptions)) {
            if (code.toLowerCase().includes(lowerCaseQuery)) {
              for (const description of descriptions) {
                this.suggestions.push(`${code} - ${description}`);
              }
            } else {
              for (const description of descriptions) {
                if (description.toLowerCase().includes(lowerCaseQuery)) {
                  this.suggestions.push(`${code} - ${description}`);
                }
              }
            }
          }
        }
      }
      this.suggestions = this.suggestions.slice(0, 10);
    }
  }

  selectDescription(suggestion: string): void {
    this.inputForm.get('codeAndDescription')?.setValue(suggestion);
    this.suggestions = [];
  }
}
